<section class="order-info-container">
  <div class="order-info-header-container">
    <div class="order-info-container-title">{{ 'text_orderInformation' | dbText }}</div>
    <div class="order-status-container">
      {{ 'text_orderStatus' | dbText }} <span class="ml5">{{order?.status}}
        <i *ngIf="order?.status==='completed'" class="ml5 db-icon db-icon-add-website-finish"></i></span>
    </div>
  </div>
  <div class="order-info-body-container" *ngIf="pageData?.stats?.stats?.length">
    <div class="order-info-body-column">
      <div class="order-info-line">
        <div class="order-info-title">{{ 'text_user' | dbText }}</div>
        <div class="order-info-value underline cursor" [routerLink]="['../../../customers/customer-view/'+pageData.stats.stats[0]['userId']]">{{pageData.stats.stats[0].value}}</div>
      </div>
      <div class="order-info-line">
        <div class="order-info-title">{{ 'text_transactionId' | dbText }}</div>
        <div class="order-info-value underline">{{pageData.stats.stats[3].value}}</div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="order-info-body-column">
      <div class="order-info-line">
        <div class="order-info-title">{{ 'text_orderQuantity' | dbText }}</div>
        <div class="order-info-value">{{pageData.stats.stats[2].value}}</div>
      </div>
      <div class="order-info-line">
        <div class="order-info-title">{{ 'text_orderDate' | dbText }}</div>
        <div class="order-info-value">{{pageData.stats.stats[1].value}}</div>
      </div>
    </div>
  </div>
  <db-order-address [order]="order">
  </db-order-address>
</section>



